// PARAQTA — API клиент ядросы (fetch wrapper).
// Барлық backend GET/POST шақырулары осы функция арқылы өтеді.
// Cookie-credentials автоматты түрде жіберіледі.
// Error болса — {} қайтарады (UI fallback render-ды үзбеу үшін).

export async function api(url, opts = {}) {
  try {
    const r = await fetch(url, { credentials: 'include', ...opts });
    if (!r.ok) return {};
    return await r.json();
  } catch {
    return {};
  }
}
